class ContentBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.innerBlocks = block.querySelectorAll('.block__inner-blocks > *');

    if (!document.body.classList.contains('wp-admin') && !this.innerBlocks.length) {
      block.classList.add('block--empty');
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.block').forEach((block) => {
  new ContentBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=block', ($block, attributes) => {
    new ContentBlock($block.find('.block').get(0), attributes);
  });
}